module.exports = __webpack_public_path__ + "img/beast2.036d75f6.png";